var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategoryConcern = function SvgCategoryConcern(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.94 86c-.45 0-.9 0-1.35-.44-1.35-.45-2.25-2.22-1.8-3.55l3.6-23.92H18.45a3.8 3.8 0 0 1-3.15-1.78c-.45-.88-.45-2.65.45-3.54l35.6-43.42a2.97 2.97 0 0 1 4.06-.89c1.35.44 2.25 2.22 1.8 3.55l-3.15 23.92h27.49c1.35 0 2.7.89 3.15 1.77.45 1.33.45 2.66-.45 3.55l-35.6 43.42c-.9.89-1.8 1.33-2.7 1.33zM25.66 51.44H50c.9 0 1.8.44 2.7 1.33.45.89.9 1.77.9 2.66l-2.25 15.5 22.99-28.35H50c-.9 0-1.8-.44-2.7-1.33-.45-.89-.9-1.77-.45-2.66l2.25-15.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryConcern);
export default ForwardRef;